































import { Component } from "../../../Infrastructure/CorBase/CoreBase";
import NotificationTemplateListBase from "./NotificationTemplateListBase";

@Component
export default class NotificationTemplateList extends NotificationTemplateListBase {
	created() {
		super.initializeRights('COR_NotificationTemplate_Create', 'COR_NotificationTemplate_Delete', 'COR_NotificationTemplate_Read', 'COR_NotificationTemplate_Update');
		this.initEnum();
		super.created();
		super.setDetailName('NotificationTemplateDetail');
	}

	selectRows(items: any) {
		super.selectRows(items);
	}

	private contentModalText(): string {
		return this.contentModal;
	}

	//private sendAgain(items: any) {
	//	this.sendAgainBase(items);
	//}

	showAllertToDeleteClick(itemsSelected: any) {
		this.showAlertBeforeDeleteBase(itemsSelected);
	}
	showAllertToDeleteClickList(itemsSelected: any) {
		this.showAllertToDeleteClickListBase(itemsSelected);
	}

	loadFilters(value: any) { super.loadFilters(value); }
	createNewClick(elementId: any) { super.createNewClick(elementId); }
	detailClick(elementId: any) { super.detailClick(elementId); }
	deleteClick(elementId: any) { this.deleteClick(elementId) }
};
